import { isRecord } from '../../utils/type/isRecord'
import type { PinoLog, PinoLevelLabel } from './PinoLog'

export const PINO_LOG_VALUE_TO_LABEL: Record<number, PinoLevelLabel> = {
  10: 'trace',
  20: 'debug',
  30: 'info',
  40: 'warn',
  50: 'error',
  60: 'fatal',
}

export const isPinoLog = (value: unknown): value is PinoLog => {
  return (
    isRecord(value) &&
    typeof value.time === 'number' &&
    typeof value.level === 'number' &&
    (typeof value.hostname === 'string' ||
      typeof value.hostname === 'undefined') &&
    value.level in PINO_LOG_VALUE_TO_LABEL
  )
}
